import $ from 'jquery';

export default () => {
  let $article = $('.article-content');

  if ($article.length > 0) {
    $article.find('iframe, img').parent().addClass('section-grow');
  }
}